module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticStyle: {
      "background-color": "#2b3033"
    },
    attrs: {
      "left-options": {
        backText: ""
      }
    }
  }, [_vm._v("\n    产品升级\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('group', {
    staticStyle: {
      "margin": "0 0.1rem",
      "border-radius": "0.3rem"
    },
    attrs: {
      "label-width": "5em"
    }
  }, [_c('popup-picker', {
    attrs: {
      "title": "CPU",
      "data": _vm.Cpu,
      "columns": 1
    },
    model: {
      value: (_vm.shengjiForm.cpu),
      callback: function($$v) {
        _vm.$set(_vm.shengjiForm, "cpu", $$v)
      },
      expression: "shengjiForm.cpu"
    }
  }), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "内存",
      "data": _vm.Ram,
      "columns": 1
    },
    model: {
      value: (_vm.shengjiForm.ram),
      callback: function($$v) {
        _vm.$set(_vm.shengjiForm, "ram", $$v)
      },
      expression: "shengjiForm.ram"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-number', {
    attrs: {
      "title": "SSD数据盘",
      "min": 10,
      "max": 1000,
      "width": "100px",
      "step": 10
    },
    model: {
      value: (_vm.shengjiForm.ssd),
      callback: function($$v) {
        _vm.$set(_vm.shengjiForm, "ssd", $$v)
      },
      expression: "shengjiForm.ssd"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "0.19rem",
      "right": "1.1rem"
    }
  }, [_vm._v("GB")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('x-number', {
    attrs: {
      "title": "公网带宽",
      "min": 5,
      "max": 300,
      "width": "150px",
      "step": 1
    },
    model: {
      value: (_vm.shengjiForm.net),
      callback: function($$v) {
        _vm.$set(_vm.shengjiForm, "net", $$v)
      },
      expression: "shengjiForm.net"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "absolute",
      "top": "0.19rem",
      "right": "1.1rem"
    }
  }, [_vm._v("Mbps")])], 1), _vm._v(" "), _c('popup-picker', {
    attrs: {
      "title": "优惠券",
      "data": _vm.shengjiForm.yhq,
      "columns": 1
    },
    on: {
      "on-hide": _vm.levelPrice
    },
    model: {
      value: (_vm.shengjiForm.coupon),
      callback: function($$v) {
        _vm.$set(_vm.shengjiForm, "coupon", $$v)
      },
      expression: "shengjiForm.coupon"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "余额"
    }
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm.shengjiForm.money))])]), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "所需费用"
    }
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm.shengjiForm.price))])])], 1), _vm._v(" "), _c('x-button', {
    staticStyle: {
      "background-color": "#00aaff",
      "color": "#fff",
      "margin-top": ".5rem",
      "width": "97%"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.Level($event)
      }
    }
  }, [_vm._v("确认")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-inner-wrap"
  }, [_c('div', {
    staticClass: "alert-warn margin-bottom-20 domain-list"
  }, [_c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("服务器升级后，到期时间不变，差价的计算精确到天；")]), _vm._v(" "), _c('p', {
    staticClass: "line-left-dot"
  }, [_vm._v("升级价格计算公式：(升级配置价格[月] - 原始配置价格[月]) * 12 / 365 * 到期剩余天数。")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c5afd85","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/serverlevel.vue
// module id = RCX2
// module chunks = 1